import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Pagos',
    path: '/pagos/comisiones',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ComisionesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Comisiones</PageTitle>
      <View />
    </>
  );
};

export { ComisionesPage };
